function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75058 9.33147L1.2159 8.18607C1.04051 8.5619 0.890176 8.94848 0.75058 9.33147ZM13.9335 2.87858e-06C11.2522 0.00291255 8.62824 0.77596 6.37367 2.22718C4.1191 3.6784 2.32886 5.74672 1.2159 8.18607L9.95677 13.1077L11.453 13.9596L11.8109 13.7592L18.5759 10.0223L18.6726 9.9686L25.52 6.16013C24.2415 4.26236 22.5161 2.70797 20.4957 1.63378C18.4752 0.559588 16.2217 -0.00146646 13.9335 2.87858e-06ZM11.4279 12.2952L3.22036 7.67063C4.21868 5.97062 5.60702 4.53242 7.27077 3.47476C8.93452 2.4171 10.826 1.77032 12.789 1.58779C14.752 1.40527 16.7303 1.69224 18.5605 2.42503C20.3907 3.15781 22.0204 4.31538 23.3151 5.80219L11.4279 12.2952Z",
  fill: "#00B0ED"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1562 21.0683L2.56889 8.94844L1.22662 8.17529C0.995851 8.68367 0.797397 9.20611 0.632442 9.73949C-0.322179 12.8046 -0.192907 16.1048 0.998543 19.0858C2.18999 22.0668 4.37103 24.547 7.17529 26.1097C9.97955 27.6724 13.2362 28.2225 16.3981 27.6675C19.5601 27.1125 22.4347 25.4863 24.5392 23.062C24.8823 22.6715 25.2026 22.2616 25.4985 21.8342L24.1562 21.0683ZM13.98 26.3514C12.0559 26.3492 10.1584 25.9014 8.43636 25.0432C6.71428 24.1849 5.21438 22.9394 4.05421 21.4044C2.89404 19.8695 2.10513 18.0866 1.74932 16.1957C1.3935 14.3048 1.48045 12.3572 2.00335 10.5055L23.1647 22.296C22.0006 23.5743 20.5823 24.5954 19.0007 25.2937C17.419 25.9921 15.7089 26.3524 13.98 26.3514Z",
  fill: "#FF0000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7826 9.10239L16.4641 13.6017L15.8305 13.9596L16.5142 14.3176L24.7826 18.8312L25.4985 19.2249V8.71582L24.7826 9.10239ZM24.7826 18.1618L17.1299 13.9918L24.7826 9.81827V18.1618Z",
  fill: "#FFCC2E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.859 18.4863V15.5784H137.557V12.8089H131.859V10.358H137.834V7.63696H131.859H127.767V10.358V12.8089V15.5784V18.4863V21.2142H131.859H138V18.4863H131.859Z",
  fill: "#0A2540"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.3564 18.4867V15.5718H92.0615V12.8023H86.3564V10.3514H92.3384V7.63037H86.3564H82.2645V10.3514V12.8023V15.5718V18.4867V21.2077H86.3564H92.5046V18.4867H86.3564Z",
  fill: "#0A2540"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M119.119 13.73V16.4994H120.912V18.0434C120.608 18.1196 116.53 19.0543 115.228 15.8071C115.228 15.8071 113.94 12.6499 117.388 10.739C117.388 10.739 120.296 9.30578 124.257 11.6183V8.42647C124.257 8.42647 117.374 5.9478 113.276 8.99421C113.276 8.99421 110.88 10.5382 110.832 14.3947C110.791 15.616 111.085 16.8252 111.682 17.8916C112.279 18.958 113.155 19.8413 114.217 20.4459C114.217 20.4459 118.129 22.6961 124.54 20.2867V13.73H119.119Z",
  fill: "#0A2540"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.936 8.67565C103.707 7.4017 99.3174 7.63018 99.3174 7.63018H98.8812H95.2462V21.2213H102.571C103.435 21.2422 104.296 21.1206 105.119 20.8613C106.179 20.4799 107.114 19.8156 107.823 18.9405C108.533 18.0654 108.989 17.0129 109.142 15.897C109.408 14.5101 109.243 13.075 108.67 11.7842C108.097 10.4934 107.143 9.40876 105.936 8.67565ZM104.863 16.1532C104.171 18.5419 101.083 18.4034 101.083 18.4034H99.3174V10.3858H101.519C101.993 10.4229 102.46 10.5278 102.904 10.6974C103.395 10.9198 103.838 11.2375 104.205 11.6321C105.486 13.4391 105.022 15.1216 104.863 16.1532Z",
  fill: "#0A2540"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.8817 7.52637H77.2932V18.1611L68.0501 7.52637H66.4646V21.2144H68.3271V20.1966V10.6697L77.4732 21.2144H79.1626V7.52637H77.8817Z",
  fill: "#0A2540"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.6885 15.2947V7.52637H61.7152V15.2947L61.6529 16.8456C61.5524 17.4054 61.3081 17.9295 60.9439 18.3665C60.5798 18.8035 60.1083 19.1383 59.5758 19.3381C58.3852 19.7371 57.0969 19.7371 55.9063 19.3381C54.6739 18.6458 54.4454 18.2234 54.4454 18.2234C53.9677 17.6349 53.8638 16.2156 53.85 15.2947V7.52637H51.8836V15.6963C51.8836 16.1255 51.9598 16.9287 51.9598 16.9287C52.0425 17.6622 52.2889 18.3677 52.6808 18.9933C53.0726 19.6188 53.5999 20.1483 54.2238 20.5428C55.7255 21.2799 57.4178 21.5362 59.0704 21.2767C59.7994 21.1863 60.5027 20.9496 61.138 20.5808C61.7733 20.212 62.3276 19.7186 62.7676 19.1304C63.8269 17.7803 63.6885 15.2947 63.6885 15.2947Z",
  fill: "#0A2540"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.7996 19.0615L48.1449 16.5067C47.6368 15.8263 47.0408 15.2163 46.3724 14.6927C47.0569 14.4213 47.6435 13.9496 48.0553 13.3392C48.4672 12.7289 48.6852 12.0084 48.6807 11.2721C48.6762 10.5357 48.4495 9.81796 48.0302 9.21267C47.6109 8.60739 47.0186 8.14283 46.3309 7.87982C45.4324 7.61411 44.498 7.4903 43.5614 7.51287H40.7365V21.2148H42.6752V15.2535C44.2053 15.1635 44.2261 15.3158 44.5515 15.4751C44.8789 15.6741 45.1851 15.9061 45.4654 16.1674C45.9085 16.3405 48.9272 21.1871 48.9272 21.1871H51.2605L49.7996 19.0615ZM44.1638 13.5226H42.6752V9.22993H44.2261C46.9955 9.31301 46.6078 11.577 46.6078 11.577C46.4486 13.7026 44.1638 13.5226 44.1638 13.5226Z",
  fill: "#0A2540"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.0591 7.50562H32.3381H30.3441V21.2144H32.2897V15.267H34.076C34.8396 15.2919 35.602 15.1913 36.3331 14.9693C37.0632 14.759 37.7073 14.3213 38.1717 13.7199C38.6361 13.1186 38.8967 12.3848 38.9156 11.6252C39.1441 7.63024 35.0591 7.50562 35.0591 7.50562ZM36.9701 11.5906C36.88 13.6677 34.4845 13.5292 34.4845 13.5292H32.3381V9.23653H34.3668C34.895 9.18536 35.4274 9.27369 35.9107 9.4927C36.286 9.68425 36.5893 9.99206 36.7752 10.3702C36.9612 10.7483 37.0198 11.1764 36.9424 11.5906H36.9701Z",
  fill: "#0A2540"
});

function SvgPrunedgeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 28,
    viewBox: "0 0 138 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrunedgeLogo);
export default __webpack_public_path__ + "static/media/prunedge-logo.cabc5e54.svg";
export { ForwardRef as ReactComponent };